import type { Column } from 'react-table';
import { useTable, useFlexLayout, usePagination } from 'react-table';
import { AnimatedLoader } from '@trinity/chat-components/components/presentation/AnimatedLoader.js';
import { GroupTable, GroupTableFooter } from '@/components/presentation/GroupTable';
import { Card, CardContent, GroupCardHeader } from '@trinity/chat-components/components/presentation/Main/index.js';
import { useFilesTableColumns } from './hooks';
import type { FilesTableItem } from './interfaces';
import styles from './style/Table.module.css';
import ViewAll from './ViewAll';

type Props = {
  data: FilesTableItem[];
  countText: string;
  pagination?: boolean;
  pageSize: number;
  isLoading: boolean;
  viewAll?: boolean;
};

export default function SearchTableFiles({ data, countText, pagination, pageSize, isLoading, viewAll }: Props) {
  const columns = useFilesTableColumns() as Column<FilesTableItem>[];

  const tableInstance = useTable<FilesTableItem>(
    {
      columns,
      data,
      initialState: {
        pageIndex: 0,
        pageSize,
      },
    },
    useFlexLayout,
    usePagination,
  );

  const tableClasses = {
    body: styles.body,
    td: styles.td,
    tr: styles.tr,
  };

  const footerClasses = {
    root: styles.footer,
    pageSize: styles.rows,
  };

  return (
    <Card className={styles.card}>
      <GroupCardHeader className={styles.header}>
        <div className={styles.left}>
          <div>Files <span className={styles.count}>{countText}</span></div>
        </div>
        {viewAll && (
          <div className={styles.right}>
            <ViewAll tab="files" />
          </div>)}
      </GroupCardHeader>
      <CardContent className={styles.content} fluid>
        {!isLoading && !!data.length &&
          <GroupTable
            classes={tableClasses}
            instance={tableInstance} />}
        {isLoading && (<AnimatedLoader className={styles.loading} />)}
        {!isLoading && pagination && !!data.length &&
          <GroupTableFooter
            classes={footerClasses}
            instance={tableInstance} />}
      </CardContent>
    </Card>
  );
}

export { SearchTableFiles };